import { SxProps, Theme } from "@mui/material"

export const footerCont: SxProps<Theme> = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  width: "100%",
  maxWidth: "100vw",
  placeItems: "center",
  backgroundColor: "transparent",
  zIndex: 96,
  "@media (min-width: 768px)": {
    display: "none",
  },
}

export const footerNav: SxProps<Theme> = {
  display: "flex",
  height: "70px",
  width: "100%",
  justifyContent: "space-around",
  alignItems: "center",
  backgroundColor: "var(--Schemes-Surface-Container)",
  padding: "0 8px",
  gap: "8px",
  "@media (min-width: 638px)": {
    padding: "0px 32px",
  },
}

export const footerNavItem: SxProps<Theme> = {
  position: "relative",
  padding: 0,
  minWidth: "40px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  textAlign: "center",
  color: "var(--Schemes-On-Surface)",
  gap: "4px",
  "&.Mui-selected:not(:nth-of-type(2))": {
    //исправить на 3, если 5 иконок в меню
    color: "var(--Schemes-Primary)",
    svg: {
      background: "var(--Schemes-Secondary-Container)",
      fill: "var(--Schemes-Primary)",
      borderRadius: "16px",
      width: "64px",
      height: "32px",
      padding: "4px",
    },
  },
  "&:nth-of-type(2)": {
    //исправить на 3, если 5 иконок в меню
    transform: "translateY(-32px)",
  },
  "&:nth-of-type(2) svg": {
    //исправить на 3, если 5 иконок в меню
    background: "var(--Schemes-Primary)",
    fill: "var(--Schemes-On-Primary)",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    padding: "8px",
  },
}
